import { render, staticRenderFns } from "./SummaryBoxSpecific.vue?vue&type=template&id=4264c202&scoped=true&"
import script from "./SummaryBoxSpecific.vue?vue&type=script&lang=js&"
export * from "./SummaryBoxSpecific.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBoxSpecific.vue?vue&type=style&index=0&id=4264c202&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264c202",
  null
  
)

export default component.exports